import { render, staticRenderFns } from "./ReportTraining.vue?vue&type=template&id=13240f24"
import script from "./ReportTraining.vue?vue&type=script&lang=js"
export * from "./ReportTraining.vue?vue&type=script&lang=js"
import style0 from "./ReportTraining.vue?vue&type=style&index=0&id=13240f24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports